import React, { useState, useEffect, useCallback } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Grid from "@mui/material/Grid";
import { Button, Typography } from "@mui/material";
import { Box } from "@mui/system";
import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import ButtonGroup from "@mui/material/ButtonGroup";
import { map, sortBy, find } from "lodash";

import AssetList from "../../Components/List/SelectionList";
import Confirmation from "../../Components/Modal/Confirmation";
import { getPodcastInfo, getPodcastLearners, updatePodcast } from "./Services";
import { getFormatedDate, getFormatedTime } from "../../Js/TimeAndDate";
import { assignmentSliceActions } from "../../Store/Slices/AssignSlice";
import { userLogs, durationCalculate, getClassNames } from "../../Js/Common";
import {
  getRolesBySiteUuid,
  getUsersByRoleId,
} from "../../Layouts/Users/Services";
import { joinByKeys } from "../../Js/Common";

const PodcastInfo = (props) => {
  // Hooks
  const navigation = useNavigate();
  const dispatch = useDispatch();
  let { id } = useParams();

  // State
  const [podcastInfo, setPodcastInfo] = useState(null);
  const [learnerList, setLearnerList] = useState(null);
  const [confirmModal, setConfirmModal] = useState(false);
  const [startTime, setStartTime] = useState(0);
  const [classes, setClasses] = useState([]);
  const [trainers, setTrainers] = useState([]);

  // Redux state
  const userInfo = useSelector((state) => state.loggedInUserInfo.userInfo);

  const initialRender = useCallback(async () => {
    let trainerUuids = [];
    let resTrainer = await getTrainerRole();
    if (resTrainer) {
      let params = {
        query: {
          $select: ["uid", "name"],
          role_uid: resTrainer.uid,
          site_uuid: userInfo.site_uuid,
          status: true,
          $limit: -1,
        },
      };
      let resUsersData = await getUsersByRoleId(params);
      // console.log("resUsersData===>", resUsersData);
      if (resUsersData.data.length > 0) {
        let trainerUuids = resUsersData.data.map((userData) => {
          delete userData.rolesInfo;
          let newUserData = {};
          newUserData.name = joinByKeys(
            userData.name,
            ["firstname", "lastname"],
            " "
          );
          newUserData.value = userData.uid;
          return newUserData;
        });
        console.log("trainerUuids", trainerUuids);
        setTrainers(trainerUuids);
      }
    }
  }, [userInfo]);

  const getTrainerRole = async () => {
    let params = {
      query: {
        $select: ["uid", "title"],
        title: "Trainer",
        site_uuid: userInfo.site_uuid,
      },
    };
    let resRolesData = await getRolesBySiteUuid(params);
    return resRolesData.data[0];
  };

  // React logic hooks
  useEffect(() => {
    if (userInfo) {
      const innerFunction = async () => {
        setClasses(await getClassNames(userInfo.site_uuid));
        initialRender();
      };
      innerFunction();
    }
  }, [userInfo]);

  useEffect(() => {
    fetchPodcastInfo();
    dispatch(assignmentSliceActions.resetState());
    //dispatch(assignmentSliceActions.setDurationFlag(false));
    //setStartTime(Date.now());
  }, [classes]);

  // Fetch Assignment Information
  const fetchPodcastInfo = async () => {
    let podcastInfoData = await getPodcastInfo(id, userInfo.site_uuid);
    setPodcastInfo(podcastInfoData.data[0]);
    let learners = await getPodcastLearners(
      podcastInfoData.data[0].context.user_uuid,
      userInfo.site_uuid,
      [true, false]
    );
    setLearnerList(
      sortBy(withClassName(learners.data), [
        "classname",
        (o) => {
          return o.name.firstname;
        },
      ])
    );
  };

  // To drop logs
  const logFunction = async (action, duration) => {
    let logResponse = await userLogs({
      actor: userInfo.uid,
      verb: "assignment",
      target: podcastInfo.uid,
      outcome: {
        value: "",
        action: action,
        duration: duration,
      },
      site_uuid: userInfo.site_uuid,
    });
  };

  const withClassName = (learners) => {
    return learners.map((val) => {
      return {
        ...val,
        classname: className(val.belongs_to),
      };
    });
  };

  const className = (id) => {
    console.log("classes", classes);
    let foundObj = find(classes, { id: id });
    if (foundObj) {
      return foundObj.value;
    }
    return "NA";
  };

  // Delete Action
  const deleteConfirm = async () => {
    let response = await updatePodcast(
      {
        is_deleted: true,
      },
      podcastInfo.uid,
      userInfo.site_uuid
    );
    if (response.status == 200) {
      setConfirmModal(false);
      //logFunction("delete", 0);
      navigation("/Podcast");
    }
  };

  // Edit Action
  const edit = () => {
    //navigation(`/Assign/Edit/${assignmentInfo.uid}`);
  };

  const getTrainerName = (uid) => {
    let foundObj = trainers.find((o) => o.value == uid);
    return foundObj.name;
  };

  return (
    <Grid container>
      <Grid item xs={12} sx={{}}>
        <Grid
          container
          sx={{
            flexDirection: "row",
            justifyContent: "space-around",
            pt: 2,
            pl: 3,
            pr: 7,
            backgroundColor: "#F5F7FF",
            overflow: "auto",
            width: "95%",
            marginLeft: 4,
            borderRadius: 5,
          }}
        >
          <Grid container xs={9} sx={{}}>
            {podcastInfo && trainers && trainers.length > 0 && (
              <Box>
                <Typography
                  color="primary.main"
                  sx={{
                    lineHeight: 2,
                    "@media (min-width: 1636px)": {
                      fontSize: "1.4rem",
                    },
                  }}
                >
                  <b>Name: </b>{" "}
                  {podcastInfo?.context?.title
                    ? podcastInfo?.context?.title
                    : ""}
                </Typography>
                <Typography
                  color="primary.main"
                  sx={{
                    lineHeight: 2,
                    "@media (min-width: 1636px)": {
                      fontSize: "1.4rem",
                    },
                  }}
                >
                  <b>Approving Trainer:</b>{" "}
                  {getTrainerName(podcastInfo?.approval_by)
                    ? getTrainerName(podcastInfo?.approval_by)
                    : ""}
                </Typography>
                <Typography
                  color="primary.main"
                  sx={{
                    lineHeight: 2,
                    "@media (min-width: 1636px)": {
                      fontSize: "1.4rem",
                    },
                  }}
                >
                  <b>Guest:</b>{" "}
                  {podcastInfo?.context?.guest
                    ? podcastInfo?.context?.guest
                    : ""}
                </Typography>
                <Typography
                  color="primary.main"
                  sx={{
                    lineHeight: 2,
                    "@media (min-width: 1636px)": {
                      fontSize: "1.4rem",
                    },
                  }}
                >
                  <b>Created At:</b>{" "}
                  {podcastInfo.createdAt
                    ? getFormatedDate(
                        podcastInfo.createdAt,
                        "DD MMM YY | HH:mm"
                      )
                    : ""}
                </Typography>
              </Box>
            )}
          </Grid>
          <Grid container xs={3} sx={{ justifyContent: "right" }}>
            <Box
              sx={{
                display: "flex",
                "& > *": {
                  m: 1,
                  pl: 5,
                },
              }}
            >
              <Typography
                color="primary.main"
                sx={{
                  lineHeight: 2,
                  "@media (min-width: 1636px)": {
                    fontSize: "1.4rem",
                  },
                }}
              >
                {""}
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "flex-end",
                "& > *": {
                  my: 3,
                  mt: 10,
                },
              }}
            >
              <ButtonGroup
                variant="text"
                sx={{ backgroundColor: "#FFFFFF", borderRadius: 15 }}
              >
                {/* <Button sx={{ px: 2 }}>
                  <BorderColorOutlinedIcon
                    onClick={edit}
                    sx={{
                      "@media (min-width: 1636px)": {
                        fontSize: "2rem",
                      },
                    }}
                  />
                </Button> */}
                <Button sx={{ px: 2 }} onClick={() => setConfirmModal(true)}>
                  <DeleteOutlineIcon
                    sx={{
                      color: "#c40000",
                      "@media (min-width: 1636px)": {
                        fontSize: "2rem",
                      },
                    }}
                  />
                </Button>
              </ButtonGroup>
            </Box>
          </Grid>
        </Grid>
        <Grid sx={{ pt: 3, pl: 3, pr: 7 }}>
          {/* <Grid container xs={12} justifyContent="end">
            <Button
              variant="contained"
              size="small"
              sx={{ px: 4, borderRadius: 15 }}
            >
              Assign Task
            </Button>
          </Grid> */}
          <Box>
            <Typography
              color="primary.main"
              sx={{
                pl: 3,
                "@media (min-width: 1636px)": {
                  fontSize: "1.4rem",
                },
              }}
            >
              <b>Learners</b>
            </Typography>
            {learnerList &&
              learnerList.map((val, index) => {
                return (
                  <div key={`${index}_assets`}>
                    <AssetList
                      title={`${index + 1}. ${val.name.firstname} ${
                        val.name.lastname
                      } - (${val.classname})`}
                      viewOnly={true}
                      deleted={!val.status}
                    ></AssetList>
                  </div>
                );
              })}
          </Box>
        </Grid>
        <Confirmation
          image="delete"
          primaryText="Delete Podcast"
          secondaryText="Do you want to delete this podcast ?"
          visible={confirmModal}
          positiveClick={deleteConfirm}
          negativeClick={() => {
            setConfirmModal(false);
          }}
          toggleModal={(flag) => setConfirmModal(flag)}
        ></Confirmation>
      </Grid>
    </Grid>
  );
};

export default PodcastInfo;
